const locale = {
  cancel: 'Cancel',
  confirm: 'Confirm',
  reset: 'Reset'
};
export default locale;